module.exports = __webpack_public_path__ + "static/media/lun.a23e24d6.svg";